import React from 'react';
import styles from './InformationBlock.module.css';
import { FormattedNumber } from '../../../../../../components';

export const AccountIndicatorsBlock = ({
  label,
  value,
  format,
  suffix,
  lonelyBlock = false,
}: {
  label: string;
  value: number | undefined;
  format: Intl.NumberFormatOptions;
  suffix?: string;
  lonelyBlock?: boolean;
}) => {
  return (
    <div
      className={`${
        lonelyBlock
          ? styles.accountIndicatorsLonelyBlock
          : styles.accountIndicatorsBlock
      }`}
    >
      <div className={styles.accountIndicatorText}>{label}</div>
      <div className={styles.accountIndicator}>
        <FormattedNumber
          value={value || 0}
          options={format}
          fontWeight={600}
          fontSize={22}
        />
        {suffix && <span className={styles.formattedNumber}>{suffix}</span>}
      </div>
    </div>
  );
};
